import { companyHasSinglePermission, userHasSinglePermission } from 'util/PermissionsUtils';
import { Permission as P } from 'common/models/Permissions';

export const AllowJobsModule = () =>
  userHasSinglePermission(P.Jobs) && companyHasSinglePermission(P.Jobs);
export const AllowJobsAddEdit = () =>
  userHasSinglePermission(P.JobsAddEdit) && companyHasSinglePermission(P.JobsAddEdit);
export const AllowJobsDelete = () =>
  userHasSinglePermission(P.JobsDelete) && companyHasSinglePermission(P.JobsDelete);
export const AllowJobsReportsAccess = () => userHasSinglePermission(P.JobsReports);
